import { configureStore } from "@reduxjs/toolkit";
import uiSlice from "./ui-slice";
import authSlice from "./auth-slice";
import initializeAppSlice, { initializedActions } from "./initial-app-slice";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import { api } from "./RTKQuery/api";
import licenseSlice from "./license-slice";
import projectSlice from "./project-slice";
import notificationSlice from "./notification-slice";
import migratedLicenseSlice from "./migrated-license-slice";

const authMiddleware = (store: any) => (next: any) => (action: any) => {
    if (initializedActions.initializedFiled.match(action)) {
        localStorage.removeItem("auth");
        console.error("initialized Filed!!!");
    } else if (initializedActions.initializedSuccess.match(action)) {

    }
    return next(action);
};

const store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        initializeApp: initializeAppSlice.reducer,
        [api.reducerPath]: api.reducer,
        license: licenseSlice.reducer,
        migratedLicenses: migratedLicenseSlice.reducer,
        ui: uiSlice.reducer,
        project: projectSlice.reducer,
        notification: notificationSlice.reducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    }).concat(api.middleware, authMiddleware,)
});

setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {auth: authSlice, ui: uiSlice.reducer}
export type AppDispatch = typeof store.dispatch;

export default store;